"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TASK_OWNER = void 0;
exports.TASK_OWNER = {
    AUTORESPONDER: 'AUTORESPONDER',
    ARTWORK: 'ARTWORK',
    CAMPAIGN: 'CAMPAIGN',
    CART: 'CART',
    CUSTOMER_ACCOUNT: 'CUSTOMER_ACCOUNT',
    CUSTOMER_SUBSCRIPTION: 'CUSTOMER_SUBSCRIPTION',
    LANDING: 'LANDING',
    ORDER: 'ORDER',
    PRODUCT: 'PRODUCT',
    USER: 'USER',
    WORKSPACE: 'WORKSPACE',
    TEMPLATE: 'TEMPLATE',
    QUIZ: 'QUIZ'
};
//# sourceMappingURL=taskOwner.js.map